import './CountryPage.css';

export const WorkOptions = ({ country }) => {
    return (
        <div className="main-content">
            <section className="work-opportunities">
                <h2>Part-time Work Options for International Students in { country.name }</h2>
                <p>{ country.workOptions.partTimeWork }</p>
                
                <h3>Post-Study Work Permit in { country.name }</h3>
                <p>{ country.workOptions.postStudyWork }</p>
            </section>
        </div>
    )
}